import { render } from "./AssociacaoView.vue?vue&type=template&id=7c69e1b3"
import script from "./AssociacaoView.vue?vue&type=script&lang=js"
export * from "./AssociacaoView.vue?vue&type=script&lang=js"

import "./AssociacaoView.vue?vue&type=style&index=0&id=7c69e1b3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__